module.exports = __webpack_public_path__ + "img/CM-SS-24-Subaru-Playful.e28d7053.jpg";